import { render, staticRenderFns } from "./CargaMasiva.vue?vue&type=template&id=20345f50&"
import script from "./CargaMasiva.vue?vue&type=script&lang=js&"
export * from "./CargaMasiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports